import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import useIsAboveBreakpoint from '../../../core/hooks/useIsAboveBreakpoint';
import Alert from '../../common/Alert/Alert';

export type Props = {
  bold?: boolean;
  message?: string;
  title?: string;
};

const PlainTextInformation = ({ bold, message, title }: Props) => {
  const isAboveMD = useIsAboveBreakpoint('MD');
  const { t } = useTranslation('component');

  return message ? (
    <div className="flex flex-col gap-4 pt-8">
      <Alert severity="warning" size="medium" className="items-center">
        <div className="flex items-center gap-4">
          <b>{title || t('plain_text_information.title')}</b>
        </div>
      </Alert>
      <p
        className={classNames('text-sm whitespace-pre-wrap', {
          'pl-4': isAboveMD,
          'font-bold': bold,
        })}
      >
        {message}
      </p>
    </div>
  ) : null;
};

export default PlainTextInformation;
